<template>
  <div>
    <el-button type="primary" @click="openWindow" :disabled="isShow"
      >选择资产</el-button
    >
    <el-dialog
      append-to-body
      title="选择资产"
      :visible.sync="deviceVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%"
    >
      <div style="float: right; margin-right: 30px">
        <el-form
          :inline="true"
          :model="formInline"
          size="mini"
          class="demo-form-inline"
        >
          <el-form-item label="所属单位">
            <el-cascader
              v-model="formInline.companyCode"
              :disabled="isSelect"
              style="width: 140px"
              :options="companyTree"
              :props="props"
              clearable
              :show-all-levels="false"
              filterable
              placeholder="请选择单位"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="设备属性">
            <el-select v-model="formInline.deviceType" placeholder="请选择">
              <el-option
                v-for="item in devicelx"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="formInline.statue"
              style="width: 140px"
              placeholder="请选择状态"
              clearable
            >
              <el-option
                v-for="item in deviceStatuData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input
              v-model="formInline.content"
              placeholder="搜索内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="findAll">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="singleTable"
        id="singleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="300"
        @current-change="tableCz"
        highlight-current-row
        size="mini"
      >
        <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="zcbh" label="资产编号" width="120">
        </el-table-column>
        <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="所属单位"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="sbzt" label="设备状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              v-if="(scope.row.juts >= 0) & (scope.row.juts <= 30)"
              style="color: #4095e5"
              >临期</span
            >
            <span v-else-if="scope.row.juts < 0" style="color: gray">超期</span>
            <span v-else style="color: blueviolet">正常</span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="tableData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="transmit">选择</el-button>
        <el-button @click="cancal">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template> 
<script>
import { findByUserIdCompanyTree, selectAllWarning } from "../../api/api";
export default {
  name: "deviceWarning",
  props: ["transferValue", "personInfo", "show"],
  data() {
    return {
      formInline: {
        statue: "",
        content: "",
        companyCode: "",
        deviceType: 0,
      },
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
      },
      deviceStatuData: [],
      devicelx: [
        {
          value: 0,
          label: "设备",
        },
        {
          value: 1,
          label: "附件",
        },
      ],
      companyTree: [],
      isShow: false,
      total: 0,
      pageIndex: 1,
      pagesize: 5,
      data: [],
      isSelect: false,
      deviceVisible: false,
      tableData: [],
      options: [],
      singleTable: [],
      outData: {},
    };
  },
  methods: {
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
    openWindow() {
      this.deviceVisible = true;
      var user = JSON.parse(localStorage.getItem("user"));
      if (
        user.userRole == 1 ||
        (user.companyCode != null && user.companyCode == "G065")
      ) {
        this.formInline.companyCode = "";
      } else {
        // (this.isSelect = true);
        this.formInline.companyCode = user.companyCode;
      }
      this.formInline.statue = 90;
      this.formInline.jdlx = this.personInfo;
      if (this.formInline.jdlx == 0) {
        this.deviceStatuData = [
          {
            label: "30天内到期设备",
            value: 30,
          },
          {
            label: "90天内到期设备",
            value: 90,
          },
          {
            label: "180天内到期设备",
            value: 180,
          },
          {
            label: "全部设备",
            value: "",
          },
          {
            label: "正常设备",
            value: 999,
          },
        ];
      } else {
        this.deviceStatuData = [
          {
            label: "30天内到期设备",
            value: 30,
          },
          {
            label: "90天内到期设备",
            value: 90,
          },
          {
            label: "180天内到期设备",
            value: 180,
          },
          {
            label: "全部设备",
            value: "",
          },
          {
            label: "正常设备",
            value: 999,
          },
        ];
      }
      this.findAll();
    },
    tableCz(val) {
      this.outData = {};
      this.outData = val;
    },
    transmit() {
      if (this.outData == null || this.outData == "") {
        this.$message.error("请选择一条信息"); // .....失败信息
      } else {
        this.transferValue(this.outData);
        this.deviceVisible = false;
      }
    },
    cancal() {
      this.deviceVisible = false;
    },

    //查找所有信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      let map = {
        companyCode: null,
        content: this.formInline.content,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        jjts: this.formInline.statue,
        userId: userinfo.userId,
        deviceType: this.formInline.deviceType,
      };
      if ((this, this.formInline.companyCode != null)) {
        if (typeof this.formInline.companyCode === "string") {
          map.companyCode = this.formInline.companyCode;
        } else {
          map.companyCode =
            this.formInline.companyCode[this.formInline.companyCode.length - 1];
        }
      }
      selectAllWarning(map).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.tableData = data.list;
          this.total = data.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.findAll();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.findAll();
    },
  },
  created() {
    this.getCompanyTree();
    this.isShow = false;
    if (this.show != null && this.show == true) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  },
};
</script>
<style scoped></style>
  


// WEBPACK FOOTER //
// src/components/common/DeviceWarning.vue